import styled from '@emotion/styled/macro';
import { forTabletPortraitDown, Variables } from '@enter/core';
import { Icon } from '@mdi/react';
import { IOrdinalProps, ordinalColors } from './shared.styles';

interface IDirected {
    direction?: 'horizontal' | 'vertical';
}

export const LegendItem = styled.span`
    display: flex;
    align-items: center;
    font-size: 15px;
    color: ${Variables.Colors.n70};
`;
export const LegendItems = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    white-space: nowrap;
`;
export const Legend = styled.div<IDirected>`
    display: flex;
    flex-direction: column;
    margin: 24px 0;
    min-height: 50px;
    justify-content: ${(props: IDirected): string => (props.direction === 'vertical' ? 'center' : 'normal')};

    & ${LegendItems} {
        ${(props: IDirected): string =>
            props.direction === 'vertical'
                ? `
        flex-direction: column;
        justify-content: flex-start;
        padding: 0 16px 0 32px;
        ${forTabletPortraitDown(`
            flex-direction: row;
        `)};
                `
                : `
        flex-direction: row;
        justify-content: center;
        padding: 0;
            `};
    }

    & ${LegendItem}:not(:last-of-type) {
        ${(props: IDirected): string =>
            props.direction === 'vertical' ? `margin-bottom: 16px;` : `margin-right: 8px;`};

        ${forTabletPortraitDown(`
            margin: 0 8px 0 0;
        `)};
    }
`;
export const LegendIcon = styled(Icon)<IOrdinalProps>`
    height: 12px;
    width: 12px;
    margin-right: 8px;
    fill: ${ordinalColors};
`;
